define([
	"dojo/_base/declare",
	"csi/prefs",
	"csi/xml",
	"SiteAdmin/GeneratePDF",
], function(declare, csiPrefs, xml, Controller) {

	return declare(Controller, {
		bWait: true,

		toWriterRequest: function() {
			// summary: write special request to server passing in State and custom View Key
			var state = (this.m_action.m_id == "RegeneratePendingPDF" ? "Pending" : "Approved");
			var customViewKey = csiPrefs.composeKey(this.widget.getViewPreferenceKey(), null, state);
			return this.inherited(arguments)
				.addParameter("State", xml.ATTR_STRING, state)
				.addParameter("CustomViewKey", xml.ATTR_STRING, customViewKey);
		}
	});
});